import {
  CareerData,
  CareerPeriodData,
  CareerPointData,
} from '../dto/EntityRepository';
import { UpdateCareerBulkItemReq } from '../dto/ReqDtoRepository';
import { CareerPeriodType, CareerType } from '../enum/EnumRepository';
import { padCareerDatePart } from './formatCareerDate';

const asCareerStringField = (value: unknown): string => {
  if (value == null) return '';
  return String(value);
};

const asCareerDateField = (value: unknown): string =>
  padCareerDatePart(asCareerStringField(value));

/** API 응답(JSON) → 스토어 `CareerData` (null → `""`) */
export const normalizeCareer = (raw: unknown): CareerData => {
  const r = raw as Record<string, unknown>;

  const base = {
    id: String(r.id),
    careerType: r.careerType as CareerType,
    content: asCareerStringField(r.content),
    contentEn: asCareerStringField(r.contentEn),
    relatedUrl: asCareerStringField(r.relatedUrl),
    isPublic: Boolean(r.isPublic),
  };

  if (r.periodType === CareerPeriodType.PERIOD) {
    return {
      ...base,
      periodType: CareerPeriodType.PERIOD,
      isCurrent: Boolean(r.isCurrent),
      currentLabelOrig: asCareerStringField(r.currentLabelOrig),
      startYear: asCareerDateField(r.startYear),
      startMonth: asCareerDateField(r.startMonth),
      startDay: asCareerDateField(r.startDay),
      endYear: asCareerDateField(r.endYear),
      endMonth: asCareerDateField(r.endMonth),
      endDay: asCareerDateField(r.endDay),
    } satisfies CareerPeriodData;
  }

  return {
    ...base,
    periodType: CareerPeriodType.POINT,
    startYear: asCareerDateField(r.startYear),
    startMonth: asCareerDateField(r.startMonth),
    startDay: asCareerDateField(r.startDay),
  } satisfies CareerPointData;
};

export const normalizeCareerList = (list: unknown[]): CareerData[] =>
  list.map(normalizeCareer);

export const toUpdateCareerBulkItemReq = (
  career: CareerData,
): UpdateCareerBulkItemReq => {
  const base = {
    careerId: career.id,
    startYear: padCareerDatePart(career.startYear),
    startMonth: padCareerDatePart(career.startMonth),
    startDay: padCareerDatePart(career.startDay),
    relatedUrl: career.relatedUrl,
    content: career.content,
    contentEn: career.contentEn,
  };

  if (career.periodType === CareerPeriodType.POINT) {
    return {
      ...base,
      periodType: CareerPeriodType.POINT,
      endYear: '',
      endMonth: '',
      endDay: '',
    };
  }

  return {
    ...base,
    periodType: CareerPeriodType.PERIOD,
    isCurrent: career.isCurrent,
    currentLabelOrig: career.currentLabelOrig,
    endYear: career.isCurrent ? '' : padCareerDatePart(career.endYear),
    endMonth: career.isCurrent ? '' : padCareerDatePart(career.endMonth),
    endDay: career.isCurrent ? '' : padCareerDatePart(career.endDay),
  };
};
